import axios from './../api'

const getWeighTicketList = (data) => {
  return axios({
    url: '/api/pc/weigh-ticket/list',
    method: 'POST',
    data
  })
}

const getWeighTicketRemove = (ticketId) => {
  return axios({
    url: '/api/pc/weigh-ticket/remove?ticketId=' + ticketId,
  })
}

const getWeighTicketSummary = (data) => {
  return axios({
    url: '/api/pc/weigh-ticket/summary',
    method: 'POST',
    data
  })
}

const getWeighProjectList = (data) => {
  return axios({
    url: '/api/pc/weigh-project/list',
    method: 'POST',
    data
  })
}

const updateWeighProject = (data) => {
  return axios({
    url: '/api/pc/weigh-project/update',
    method: 'POST',
    data
  })
}

const getImportRecordList = (data) => {
  return axios({
    url: '/api/pc/import-record/list',
    method: 'POST',
    data
  })
}

export default {
  getWeighTicketList,
  getWeighTicketRemove,
  getWeighTicketSummary,
  getWeighProjectList,
  updateWeighProject,
  getImportRecordList
}